<template>
  <svg :id="`chart-${id}`" class="chart" />
</template>
<script>
import * as d3 from 'd3' // @todo cherrypick like this: var d3 = Object.assign({}, require("d3-format"), require("d3-geo"), require("d3-geo-projection"));

export default {
  props: {
    yScaleType: {
      type: String,
      default: 'linear'
    },
    series: {
      type: Array,
      required: true
    },
    id: {
      type: [String, Number],
      default: '1'
    },
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      chart: null,

      defaultConfig: {
        aspectRatio: 0.5,
        lineColor: '#fff',
        textColor: '#000',
        yAxis: 'left',
        curve: d3.curveMonotoneX,
        margin: {
          right: 0,
          left: 0,
          top: 0,
          bottom: 0
        }
      }
    }
  },
  computed: {
    options() {
      return { ...this.defaultConfig, ...this.config }
    },
    width() {
      return 100 //d3.min([100, 100]) // @todo: get clientWidth
    },
    height() {
      return 40 // d3.min([this.width * this.options.aspectRatio, 80])
    },
    yScale() {
      return this.yScaleType === 'log' ? this.yScaleLog : this.yScaleLinear
    },
    yScaleLinear() {
      return d3
        .scaleLinear()
        .domain(d3.extent(this.series, d => d.value))
        .range([this.height - this.options.margin.bottom, this.options.margin.top])
    },
    yScaleLog() {
      return d3
        .scaleLog()
        .base(10)
        .domain([d3.max([1, d3.min(this.series, d => d.value)]), d3.max(this.series, d => d.value)])
        .range([this.height - this.options.margin.bottom, this.options.margin.top])
    },
    xScale() {
      return d3
        .scaleTime()
        .domain(d3.extent(this.series, d => d.date))
        .range([this.options.margin.left, this.width - this.options.margin.right])
    },
    line() {
      return d3
        .line()
        .defined(d => (this.yScaleType === 'log' ? d.value > 0 : !isNaN(d.value)))
        .x(d => this.xScale(d.date))
        .y(d => this.yScale(d.value))
        .curve(this.options.curve)
    }
  },

  watch: {
    series(val) {
      this.drawChart(`#chart-${this.id}`, val)
    }
  },

  mounted() {
    this.drawChart(`#chart-${this.id}`, this.series)
  },

  methods: {
    drawChart(id, _series) {
      const series = [..._series] // copy to make sure _series is immutable (can cause infinit loop with watcher)
      const el = this.chart || d3.select(id)
      const svg = el
      const t = svg.transition().duration(750)

      // initalize on first call
      if (!el.g) {
        svg.attr('viewBox', `0 0 ${this.width} ${this.height}`)
        svg.attr('style', 'width:100%')
        el.g = svg.append('g').classed('line', true)
      }

      // el.lines.selectAll('path').remove();
      el.g
        .attr('fill', 'none')
        .attr('stroke-width', 0.75)
        .attr('stroke-linejoin', 'round')
        .attr('stroke-linecap', 'round')
        .selectAll('path')
        .data([series])
        .join('path')
        .attr('stroke', 'currentColor')
        .transition(t)
        .attr('d', this.line)

      this.chart = el
    }
  }
}
</script>
